import * as constants from '../../../constants';

export type PromoBannerViewport = typeof constants.DESKTOP | typeof constants.MOBILE;

const PURPLE_BANNER_HEIGHTS = { [constants.DESKTOP]: 48, [constants.MOBILE]: 80 };
const CORAL_SALE_BANNER_HEIGHTS = { [constants.DESKTOP]: 64, [constants.MOBILE]: 74 };

export const getPromoBannerHeight = (
  coralSaleBannerWithShopNowAndInlineCountdown: boolean,
  viewport: PromoBannerViewport,
): number => (
  coralSaleBannerWithShopNowAndInlineCountdown
    ? CORAL_SALE_BANNER_HEIGHTS[viewport]
    : PURPLE_BANNER_HEIGHTS[viewport]
);
